// generated by the plop

import { StandModel, StandModelExpectBackend, TemplateExpectBackend, TemplateGraphQLModel } from 'shared';
import { UnknownError, UUID } from 'symbols';

export class GetStandTemplateList {
  static readonly type = '[StandManage] GetStandTemplateList';
}


export class CreateStandTemplate {
  static type = '[StandManage] CreateStandTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}

export class UpdateStandTemplate {
  static type = '[StandManage] UpdateStandTemplate';

  constructor(public template: TemplateGraphQLModel, public id: UUID) {
  }
}

export class DeleteStandTemplate {
  static type = '[StandManage] DeleteStandTemplate';

  constructor(public id: UUID) {
  }
}

export class UpdateStandTemplateSuccess {
  static type = '[StandManage] UpdateStandTemplateSuccess';
}

export class UpdateStandTemplateFail {
  static type = '[StandManage] UpdateStandTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetStandById {
  static type = '[standManage] GetStandById';

  constructor(public id: UUID) {
  }
}

export class GetStandByIdSuccess {
  static type = '[standManage] GetStandByIdSuccess';

  constructor(public stand: StandModel) {
  }
}

export class GetStandByIdFail {
  static type = '[standManage] GetStandByIdFail';

  constructor(public error: UnknownError) {
  }
}

export class SetCurrentStandId {
  static type = '[standManage] SetCurrentStandId';

  constructor(public id: UUID) {
  }
}


export class UpdateLocalStand {
  static type = '[standManage] UpdateLocalStand';

  constructor(public stand: StandModel) {
  }
}

export class DeleteLocalStand {
  static type = '[standManage] DeleteLocalStand';

  constructor(public id: UUID) {
  }
}

export class UpdateStand {
  static type = '[standManage] UpdateStand';

  constructor(public id: UUID, public stand: StandModelExpectBackend, public force: boolean) {
  }
}

export class UpdateStandSuccess {
  static type = '[standManage] UpdateStandSuccess';

  constructor(public stand: StandModel) {
  }
}

export class UpdateStandFail {
  static type = '[standManage] UpdateStandFail';

  constructor(public error: UnknownError) {
  }
}

export class CreateStand {
  static type = '[standManage] CreateStand';

  constructor(public stand: StandModelExpectBackend) {
  }
}

export class CreateStandSuccess {
  static type = '[standManage] CreateStandSuccess';

  constructor(public stand: StandModel) {
  }
}

export class CreateStandFail {
  static type = '[standManage] CreateStandFail';

  constructor(public error: UnknownError) {
  }
}

export class IssuedStand {
  static type = '[standManage] IssuedStand';

  constructor(public standId: UUID) {
  }
}


export class IssuedStandSuccess {
  static type = '[standManage] IssuedStandSuccess';

  constructor(public stand: StandModel) {
  }
}

export class IssuedStandFail {
  static type = '[standManage] IssuedStandFail';

  constructor(public error: UnknownError) {
  }
}


export class ReadyToPickUpStand {
  static type = '[standManage] ReadyToPickUpStand';

  constructor(public setStatus: boolean, public stand: StandModelExpectBackend) {
  }
}


export class ReadyToPickUpStandSuccess {
  static type = '[standManage] ReadyToPickUpStandSuccess';

  constructor(public stand: StandModel) {
  }
}

export class ReadyToPickUpStandFail {
  static type = '[standManage] ReadyToPickUpStandFail';

  constructor(public error: UnknownError) {
  }
}
